import styled from "styled-components";
import { FaUserCircle } from "react-icons/fa";
import { useState } from "react";
import { MdOutlineFileUpload } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { useTheme } from "../../../context/useThemeContext";
import { FaUser } from "react-icons/fa6";
import useAccountManagementStore from "../../../stores/accountManagementStore";

const ClickableCircle = styled.div<{ $isDragOver: boolean }>`
    &:hover {
        cursor: pointer;

        .uploadPic {
            opacity: 1;
        }
        .profilePicOverlay {
            opacity: 0.5;
            backdrop-filter: blur(10px);
        }

        .deleteProfilePic {
            opacity: 1;
        }
    }
    .deleteProfilePic {
        transition: opacity 0.1s ease-in-out;
        opacity: 0;
    }
    .deleteProfilePic {
        transition: opacity 0.1s ease-in-out;
        opacity: 0;

        &:hover {
            outline: 1px solid rgba(255, 255, 255, 1);
        }
    }

    .uploadPic {
        transition: opacity 0.1s ease-in-out;
        opacity: ${(props) => (props.$isDragOver ? 1 : 0)};
    }
    .profilePicOverlay {
        transition: all 0.1s ease-in-out;
        opacity: ${(props) => (props.$isDragOver ? 0.3 : 0)};
        backdrop-filter: blur(0px);
    }
`;
type FileExt = File & {
    path: string;
};
export function ProfilePicture() {
    const { theme } = useTheme();
    const { userData } = useAccountManagementStore((state) => state);

    const [isDragOver, setIsDragOver] = useState(false);

    return (
        <div
            onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
            className="absolute left-0 right-0 ml-auto mr-auto flex h-[60px] w-[60px] -translate-y-[30px] rounded-full"
        >
            <ClickableCircle
                $isDragOver={isDragOver}
                id="loginProfilePic"
                className="absolute left-0 right-0 ml-auto mr-auto flex h-[60px] w-[60px] cursor-pointer items-center justify-center rounded-full bg-black text-center"
                style={{
                    border: "2px solid " + theme.secondaryHeaderColor,
                    pointerEvents: "none",
                }}
            >
                <div className="profilePicOverlay pointer-events-none absolute z-[1] h-full w-full overflow-hidden rounded-full bg-black opacity-0 backdrop-blur" />
                {userData?.profilePicURL !== undefined ? (
                    <>
                        {/* Overlay upload image */}
                        <div className="uploadPic pointer-events-none relative z-10 flex items-center justify-center text-white">
                            <MdOutlineFileUpload
                                size={30}
                                className="pointer-events-none  z-[10]"
                            />
                        </div>
                        {/* Profile Picture */}
                        <div className="absolute bottom-0 left-0 right-0 top-0 overflow-hidden rounded-full">
                            {userData?.profilePicURL && (
                                <img
                                    alt="Profile Picture"
                                    className="h-full w-full object-cover object-top"
                                    referrerPolicy="no-referrer"
                                    src={`${
                                        userData?.profilePicURL
                                    }?t=${new Date().getTime()}`}
                                />
                            )}
                        </div>
                    </>
                ) : (
                    <FaUser
                        size={30}
                        color={theme.fontColor[200]}
                        opacity={0.75}
                    />
                )}
                {userData?.profilePicURL !== undefined &&
                    userData?.profilePicURL !== null &&
                    userData?.profilePicURL !== "" &&
                    !userData?.profilePicURL.includes("googleusercontent") && (
                        <div
                            className="deleteProfilePic absolute top-[-3px] right-[-3px] z-50 flex h-[20px] w-[20px] items-center justify-center rounded-full"
                            style={{
                                backgroundColor: "#ce1811",
                            }}
                        >
                            <IoClose color="white" size="20" />
                        </div>
                    )}
            </ClickableCircle>
        </div>
    );
}
